import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { ActivityRoutes } from './activity/activity-routes';
import { ItemsRoutes } from './items/items-routes';
import { MyLaundryRoutes } from './my-laundry/my-laundry-routes';

const MyHome = lazy(() => import('./home/home.component'));
const MyLaundryTransactionDetail = lazy(() => import('./my-laundry/my-laundry-transaction-detail/my-laundry-transaction-detail.component'));
const MyPudoTransactionDetail = lazy(() => import('./my-pudo/my-pudo-transaction-detail/my-pudo-transaction-detail.component'));
const MyNivalizTransactionDetail = lazy(() => import('./my-nivaliz/my-nivaliz-transaction-detail/my-nivaliz-transaction-detail.component'));
const OrderDetail = lazy(() => import('../shop/orders/order-detail/order-detail.component'));

//TODO should have home page that renders all available home components from the feature list
export function MyRoutes() {
    const myLaundryRoutes = MyLaundryRoutes();
    const itemRoutes = ItemsRoutes();
    const activityRoutes = ActivityRoutes();
    return (
        <Route path='my'>
            <Route
                index
                element={<Navigate to='home' />}
            />
            <Route path='home'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <MyHome />
                        </AsyncComponent>
                    }
                />
                <Route path=':transactionId'>
                    <Route
                        path='detail'
                        element={
                            <AsyncComponent>
                                <MyLaundryTransactionDetail />
                            </AsyncComponent>
                        }
                    />
                </Route>
            </Route>
            <Route path='pudo'>
                <Route path=':transactionId'>
                    <Route
                        path='detail'
                        element={
                            <AsyncComponent>
                                <MyPudoTransactionDetail />
                            </AsyncComponent>
                        }
                    />
                </Route>
            </Route>
            <Route path='nivaliz'>
                <Route path=':transactionId'>
                    <Route
                        path='detail'
                        element={
                            <AsyncComponent>
                                <MyNivalizTransactionDetail />
                            </AsyncComponent>
                        }
                    />
                </Route>
            </Route>
            <Route
                path='orders/:orderId'
                element={
                    <AsyncComponent>
                        <OrderDetail />
                    </AsyncComponent>
                }
            />

            {itemRoutes}
            {activityRoutes}
            {myLaundryRoutes}
        </Route>
    );
}
